var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "container"
  }, [_c("img", {
    staticClass: "pic-404",
    attrs: {
      src: require("@/assets/404_images/404.png"),
      alt: "404"
    }
  }), _c("div", {
    staticClass: "message"
  }, [_c("div", {
    staticClass: "bullshit__info"
  }, [_vm._v("抱歉，您访问的页面不存在")]), _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.$router.push({
          path: "/"
        });
      }
    }
  }, [_vm._v(" 返回首页 ")])], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };